import { useEffect, useState } from 'react'
import { VscChromeClose } from 'react-icons/vsc'

export default function Modal({
  title,
  children,
  button,
  buttonCancell,
  show,
  onClose,
  size,
  footer = true
}) {
  const [bodyClass, setBodyClass] = useState(false)

  useEffect(() => {
    setBodyClass(!show)
    if (bodyClass === true) {
      document.body.classList.add('overflow')
    } else {
      document.body.classList.contains('overflow') &&
        document.body.classList.remove('overflow')
    }
  }, [show])

  return (
    <>
      <div className={`modal_box ${show ? 'show' : ''}`} onClick={onClose}>
        <div
          className={`container ${size && size}`}
          onClick={e => e.stopPropagation()}
        >
          <div className='modal_holder'>
            <div className='modal_head'>
              <div className='closeModal'>
                <VscChromeClose onClick={onClose} />
              </div>
              <span>{title}</span>
            </div>

            <div className={`${!footer && 'footerLessModal'} modal_body`}>{children}</div>

            {footer && button || buttonCancell ? (
              <div className='modal_footer'>
                {buttonCancell && (
                  <button className='cancellBtn' onClick={onClose}>
                    {buttonCancell}
                  </button>
                )}
                {button && <button onClick={onClose}>{button}</button>}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </>
  )
}
